export { default } from './OnlineJournal';
